import { render, staticRenderFns } from "./TakeMeal.vue?vue&type=template&id=fa64624c&scoped=true"
import script from "./TakeMeal.vue?vue&type=script&lang=js"
export * from "./TakeMeal.vue?vue&type=script&lang=js"
import style0 from "./TakeMeal.vue?vue&type=style&index=0&id=fa64624c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64624c",
  null
  
)

export default component.exports